import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams } from '@/types';
import { IAlertApiListResponse, IAlertUpdateParams } from '@/types/alert';

export const alertList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IAlertApiListResponse>> => {
    return axios.get('/api/alert/list', { ...config, params });
};

export const alertUpdate = (params: IAlertUpdateParams): Promise<AxiosResponse<{ success: boolean }>> => {
    return axios.post('/api/alert/update', params);
};
